module.exports = __webpack_public_path__ + "img/notification.5be988e7.svg";